import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";
import * as SkeletonUtils from "three/examples/jsm/utils/SkeletonUtils";
import {FontLoader} from "three/examples/jsm/loaders/FontLoader.js";
import {TextGeometry} from "three/examples/jsm/geometries/TextGeometry";
import * as MathUtils from "./mathUtils.js";
import * as DateUtils from "./dateUtils.js";
import {Pathfinding, PathfindingHelper} from "three-pathfinding";
import {Timer, Signal, EventManager, AvatarManager} from "./RedbrickModule";
import {createRank, getUserInfo, getRankList, aggregateRank, checkCode} from "api-gstar/index.js";

export function setupBuiltin(context) {
  const REDBRICK = {
    Timer: Timer,
    Signal: Object.freeze(new Signal()),
    EventManager: Object.freeze(new EventManager()),
    AvatarManager: Object.freeze(new AvatarManager(context)),
  };
  Object.freeze(REDBRICK);

  const THREEADDON = {
    SkeletonUtils: SkeletonUtils,
    FontLoader: FontLoader,
    TextGeometry: TextGeometry,
  };

  const NavigationUtils = {
    Pathfinding: Pathfinding,
    PathfindingHelper: PathfindingHelper,
  };

  const GSTAR = {
    USER: {
      GET: params => getUserInfo({ci: context.userInfo.ci, ...params}),
    },
    RANK: {
      GET: params => getRankList({...params, ci: context.userInfo.ci}),
      CREATE: params => createRank({...params, ci: context.userInfo.ci}),
    },
    CODE: {
      CHECK: params => checkCode({...params}),
    },
  };
  Object.freeze(THREEADDON);

  return {THREE, TWEEN, THREEADDON, MathUtils, DateUtils, NavigationUtils, REDBRICK, GSTAR};
}
